// Single source of truth for COI action-state shared across Dashboard, Jobs (and matching JobDetail).
//
// A high-risk COI is "unresolved" when the CURRENTLY-assigned auditor has a High-risk COI response on
// file AND no 'Proceed' decision has been recorded for that slot + auditor name. Two ways it resolves:
//   • Replace the auditor → the assigned name changes, so the old High-risk COI no longer matches the
//     current auditor and falls away naturally.
//   • Record a 'Proceed' decision (with justification) for that slot + name → explicit resolution.
// This mirrors JobDetail's coiConflicts() resolution rule so all three screens agree.
export function unresolvedHighRiskCoiNames(job, coiRows = [], decisionRows = []) {
  if (!job) return []
  const names = []
  const check = (slot, id, name) => {
    if (!id || !name) return
    const high = coiRows.some(c => c.job_id === job.id && c.auditor_slot === slot && c.auditor_name === name && c.risk_level === 'High')
    if (!high) return
    const proceeded = decisionRows.some(d => d.job_id === job.id && d.auditor_slot === slot && d.auditor_name === name && d.decision === 'Proceed')
    if (!proceeded) names.push(name)
  }
  check('auditor1', job.auditor_id, job.auditor_name)
  check('auditor2', job.auditor2_id, job.auditor2_name)
  return names
}
